module.exports = __webpack_public_path__ + "static/media/PrintLogo.e6aeaf75.svg";